/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForAzureDevops extends models.ServiceAccountNativeDetailsBaseForIntegratedTool {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForAzureDevops");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForAzureDevops.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForAzureDevops>): ServiceAccountNativeDetailsForAzureDevops {
        let obj = Object.assign(new ServiceAccountNativeDetailsForAzureDevops(), model);
        ServiceAccountNativeDetailsForAzureDevops.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForAzureDevops>): ServiceAccountNativeDetailsForAzureDevops {
        if (!model) return null;
        return ServiceAccountNativeDetailsForAzureDevops.newInstance(<ServiceAccountNativeDetailsForAzureDevops> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForAzureDevops) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForAzureDevops.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForAzureDevops): boolean {
        if (models.ServiceAccountNativeDetailsBaseForIntegratedTool.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForAzureDevops.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
